import _ from 'underscore';
import { useCallback, useEffect, useState } from 'react';

export const MAX_INLINE_RECOMMENDATIONS_PER_PAGE = 5;

export const useCircularBufferViewWithSelected = (unselectedCollection, selectedCollection, pageSize = MAX_INLINE_RECOMMENDATIONS_PER_PAGE) => {
  const [page, setPage] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const selectedCount = selectedCollection.length;
  const unselectedCount = unselectedCollection.length;

  useEffect(() => {
    if (unselectedCount === 0 && selectedCount === 0) {
      setPage([]);
      return;
    }

    const newPage = _.first(selectedCollection, pageSize);
    let index = currentIndex % unselectedCount;
    let count = newPage.length;
    while (count < pageSize && count < unselectedCount + selectedCount) {
      newPage.push(unselectedCollection[index]);
      index = (index + 1) % unselectedCount;
      count += 1;
    }
    setPage(newPage);
  }, [unselectedCollection, currentIndex, pageSize, selectedCollection, unselectedCount, selectedCount]);

  const canMoveNext = selectedCount < pageSize && unselectedCount > (pageSize - selectedCount);

  const moveNext = useCallback(() => {
    setCurrentIndex(((currentIndex + pageSize) - selectedCount) % unselectedCount);
  }, [currentIndex, pageSize, selectedCount, unselectedCount]);

  return [page, canMoveNext, moveNext];
};
